/**
 * reviewerQueuePost — the client's defensive mirror of the server's reviewer-queue
 * contract (server/services/social/reviewerQueue.js).
 *
 * The API already filters before paginating; keeping the predicate at navigation
 * boundaries ensures stale client state can never surface a row the reviewer
 * cannot act on — a Community-extension-only post in the queue would send the
 * operator to a screen with nothing to approve.
 *
 * It lives in its own ZERO-import module rather than in the duck so pure view
 * helpers (dashboardHelpers) can read the one contract without pulling the API
 * layer and the app config in behind it.
 *
 * @module AdminSocialPostsPage/reviewerQueuePost
 */

/**
 * Is this post something the reviewer can actually act on?
 * @param {?{status?:string, channels?:Array}} post
 * @returns {boolean}
 */
export const isReviewerQueuePost = post =>
    Boolean(
        post &&
            (post.status === 'pending_approval' ||
                (post.status === 'awaiting_manual' &&
                    (post.channels || []).some(
                        channel =>
                            channel &&
                            channel.platform === 'instagram' &&
                            channel.postType === 'story' &&
                            channel.heldForManual === true
                    )))
    );
